import { Schedule } from '@mxenabled/mx-icons'
import { MonetizationOn } from '@mxenabled/mx-icons'
import { Cancel } from '@mxenabled/mx-icons'
import { CheckCircle } from '@mxenabled/mx-icons'

import IconBacking from '../../common/components/IconBacking'

const iconStyle = {
  gridRow: 1,
  gridColumn: 1,
  zIndex: 2,
}

const offsetStyle = (isOffset: boolean) => {
  return isOffset ? { margin: '0 0 -6px -4px' } : undefined
}

export const UpcomingExpenseBadge = ({ isOffset = false, size = 16 }) => (
  <IconBacking
    backingSx={{ backgroundColor: 'background.paper' }}
    size={size}
    sx={{ ...offsetStyle(isOffset) }}
  >
    <Schedule color="primary" filled={true} sx={{ fontSize: size, ...iconStyle }} />
  </IconBacking>
)

export const IncomeBadge = ({ isOffset = false, size = 16 }) => (
  <IconBacking
    backingSx={{ backgroundColor: 'background.paper' }}
    size={size}
    sx={{ ...offsetStyle(isOffset) }}
  >
    <MonetizationOn
      filled={true}
      sx={{ color: 'categories.income', fontSize: size, ...iconStyle }}
    />
  </IconBacking>
)

export const MissedBadge = ({ isOffset = false, size = 16 }) => (
  <IconBacking
    backingSx={{ backgroundColor: 'background.paper' }}
    size={size}
    sx={{ ...offsetStyle(isOffset) }}
  >
    <Cancel color="error" filled={true} sx={{ fontSize: size, ...iconStyle }} />
  </IconBacking>
)

export const PaidBadge = ({ isOffset = false, size = 16 }) => (
  <IconBacking
    backingSx={{ backgroundColor: 'background.paper' }}
    size={size}
    sx={{ ...offsetStyle(isOffset) }}
  >
    <CheckCircle color="success" filled={true} sx={{ fontSize: size, ...iconStyle }} />
  </IconBacking>
)
